import Vue from 'vue';
import VueI18n from 'vue-i18n';

export const defaultLocale = 'nl';

Vue.use(VueI18n);

const messages = {
  en: require('../i18n/locales/en.json'),
  nl: require('../i18n/locales/nl.json'),
  de: require('../i18n/locales/de.json'),
  fr: require('../i18n/locales/fr.json'),
};

const getLocaleFromCookie = () => {
  const cookies = document.cookie.split(';');
  const djangoLanguageCookie = cookies.find(cookie => cookie.trim().startsWith('django_language='));
  const locale = djangoLanguageCookie ? djangoLanguageCookie.split('=')[1].trim() : null;
  return locale && messages[locale] ? locale : defaultLocale;
};

const i18n = new VueI18n({
  locale: getLocaleFromCookie(),
  fallbackLocale: defaultLocale,
  messages,
});

export default i18n;
